<template>
    <div class="checkoutBlock" :class="(inProgress?'processing':'')">
        <h4>Payment</h4>

        <div v-for="paymentMethod in paymentMethods" v-bind:key="paymentMethod.code"  class="form-check form-check-inline">
            <input class="form-check-input" type="radio" name="inlineRadioOptions" v-bind:id="paymentMethod.code" v-bind:value="paymentMethod.code" v-model="method" >
            <label class="form-check-label" v-bind:for="paymentMethod.code">{{paymentMethod.name}}</label>
        </div>
        <br>
        <div class="progressor"></div>
        <br>
        <div v-show="method=='PS-CC'" ref="card" class="form-control m-2">
            <!-- A Stripe Element will be inserted here. -->
        </div>
        <div class="alert alert-danger" v-if="method=='PS-CC' && stripeError.length>0">
            {{stripeError}}
        </div>

    </div>
</template>

<script>
    export default {
        name: 'Payment',
        props: {
            fetch: Boolean
        },
        data: function () {
            return {
                method: '',
            }
        },
        computed: {
            stripeError () {
                return this.$store.state.stripe.error
            },
            paymentMethods () {
                if (this.$store.state.paymentMethods.length) {
                    const keys = Object.keys(this.$store.state.paymentMethods[0].methods)
                    let result = []
                    for(const key of keys) {
                        result.push( this.$store.state.paymentMethods[0].methods[key] )
                        if (this.$store.state.cart.payments.length && key == this.cartMethod) {
                            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                            this.method = key
                        }
                    }
                    return result
                } else {
                    return []
                }
            },
            cartMethod () {
                if (this.$store.state.cart.payments.length) {
                    return this.$store.state.cart.payments[0].method.code
                } else {
                    return null
                }
            },
            inProgress() {
                return this.$store.state.inProgress
            },
        },
        mounted() {
            this.$store.dispatch('tryToRecover')
            this.$store.dispatch('initStripePayment', this.$refs.card)
        },
        methods: {
        },
        watch: {
            method (newValue) {
                if (newValue != this.cartMethod) {
                    this.$store.dispatch('updatePayment', [0, newValue])
                }
            }
        }
    }
</script>